import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Announcement } from 'src/app/core/interfaces/store-configuration.interface';

@Component({
  standalone: true,
  selector: 'announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class AnnouncementBarComponent {


  readonly announcement = input<Announcement | null>(null);
}

